import { Component, OnInit, Input } from "@angular/core";
import { BaseComponent } from "../base.component";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "viewparent",
  templateUrl: "viewparent.component.html",
})
export class ViewParentComponent extends BaseComponent {
  @Input() registeredUser: any;
  model: any = {};
  loading = false;
  messages: any;
  registeredUsers: any = [];
  modalReference: any;

  constructor(
    private modalService: NgbModal,
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  run() {
    this.registeredUsers = this.registeredUser ? [this.registeredUser] : [];
    let s = this.dataService.registeredUser.subscribe((nextVal) => {
      this.registeredUsers = nextVal && nextVal != null ? [nextVal] : [];
    });
    this.addObservable(s);
  }

  open(content) {
    let options: NgbModalOptions = {
      windowClass: "modal-opened",
      backdrop: "static",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  onCompleteSave() {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  getModalTitle() {
    if (this.registeredUser && this.registeredUser.firstName)
      return (
        this.registeredUser.firstName +
        " " +
        this.registeredUser.lastName +
        " " +
        this.base.messages["admin_parent"] +
        " - " +
        this.base.messages["admin_edit"]
      );
    else return this.base.messages["admin_edit"];
  }

  removeParentFromList(parent) {
    this.dataService.registeredUser.next(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/registereduser/viewparent.component.ts